import React, { useRef, useState, useEffect } from "react";
import { Printer, Pencil, Save, X, Upload } from "lucide-react";
import apiService from "../../config"; 
import { useSignature } from '../../DigitalSignature/UseSignatue';
import SignaturePad from '../../DigitalSignature/SignaturePad';

const AkshepList = () => {
  const printRef = useRef();
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);

  // Data from API
  const [tippani, setTippani] = useState({
    subject: "",
    subject2: "",
    reference: "",
    default_content: "",
    officer_name: "",
  officer_designation: ""
  });

  // Form data for editing
  const [formData, setFormData] = useState({
    subject: "",
    subject2: "",
    reference: "",
    default_content: "",
    officer_name: "",
  officer_designation: ""
  });

  const [fullName, setFullName] = useState('');
      const [designation , setDesignation] =useState('');
      const [showSignaturePad, setShowSignaturePad] = useState(false);
        const [pdfForSigning, setPdfForSigning] = useState(null);
        const [isViewerOpen, setIsViewerOpen] = useState(false);
        const [viewerFile, setViewerFile] = useState(null);
        const [previewUrl, setPreviewUrl] = useState(null);
        const {
          uploadStatus,
          uploadError,
          selectedSignDocument,
          resetSignatureState,
          setUploadStatus,
          setUploadError,
          signDocument
        } = useSignature();

  // Default / fallback content (your original text)
  const DEFAULT_CONTENT = {
    subject: "जिगांव प्रकल्प तालुका नांदुरा जिल्हा बुलढाणा",
    subject2:
      "जिगांव प्रकल्पामुळे बाधित मौजे ककोरा तालुका शेगांव जिल्हा बुलढाणा येथील प्रकल्पग्रस्तांचे प्राप्त आक्षेपांवरील निराकरण अहवाल प्रसिद्ध करणेबाबत.",
    reference: `या कार्यालयाचे पत्र जा.क्र. पुनर्वस/कक्ष-१२/कावी/३७९/२०२५ दिनांक २८.०७.२०२५`,
    default_content: `महोदय,

जिगांव प्रकल्पामुळे बाधित होत असलेले मौजे ककोरा तालुका शेगांव जिल्हा बुलढाणा येथील प्रकल्पग्रस्तांचे पुनर्वसनांतर्गत भूखंड वाटपाचे अनुषंगाने नवीन गावठाण मौजे ककोरा ता. शेगांव जि. बुलढाणा करिता भूखंड वाटपाची प्रारूप यादी संदर्भान्वये प्रसिद्ध करण्यात आली असता प्रकल्पग्रस्तांनी आक्षेप अर्ज या कार्यालयास सादर केलेले आहेत.

प्रकल्पग्रस्तांचे प्राप्त आक्षेप अर्जांचे (एकूण प्राप्त आक्षेप अर्ज ३४) निराकरण करण्यात आले असून त्याबाबतचा निराकरण अहवाल (पाने – १ ते २५) संलग्न करण्यात येत आहे. सदर आक्षेप निराकरण अहवाल प्रसिद्ध करून प्रसिद्धी अहवाल या कार्यालयास सादर करण्यात यावा.

तसेच सचिव, ग्राम पंचायत कार्यालय, ककोरा यांनी संबंधित प्रकल्पग्रस्तांना अवगत करावे. अशा आशयाचे पत्र तहसीलदार, शेगांव व सचिव, ग्राम पंचायत कार्यालय, ककोरा यांना कार्यवाहीस्तव तसेच कार्यकारी अभियंता, जिगांव प्रकल्प धरण व पुनर्वसन विभाग, शेगांव यांना माहितीसाठी देण्यात यावे.

सहमत असल्यास प्रारूप टिपणी स्वाक्षरीस्तव सचिवास सादर.`,
officer_name: "एम.के. जाधव",
  officer_designation: "ग्राम महसूल अधिकारी"
  };

   useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        setFullName(userData.full_name || '');
        setDesignation(userData.designation || '');
      }, []);

  // Get project & proposal IDs
  useEffect(() => {
    const getProjectId = () => {
      const current = localStorage.getItem("currentProjectData");
      if (current) {
        const p = JSON.parse(current);
        return p.project_id || p.id;
      }
      const selected = localStorage.getItem("selectedProject");
      if (selected) {
        const p = JSON.parse(selected);
        return p.project_id || p.id;
      }
      const user = localStorage.getItem("userData");
      if (user) {
        const u = JSON.parse(user);
        return u?.data?.project_id || u?.project_id || null;
      }
      return null;
    };

    const getProposalId = () => {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      return (
        userData?.data?.default_proposal ||
        userData?.data?.proposal_id ||
        userData?.default_proposal ||
        userData?.proposal_id ||
        null
      );
    };

    setProjectId(getProjectId());
    setProposalId(getProposalId());
  }, []);

  // Load tippani data
  useEffect(() => {
    const fetchTippani = async () => {
      if (!projectId || !proposalId) return;

      try {
        setLoading(true);
        const response = await apiService.getTippani(projectId, proposalId, "Objection");

        const data = response?.data || response || {};

        const loadedData = {
          subject: data?.subject?.trim() || DEFAULT_CONTENT.subject,
          subject2: data?.subject2?.trim() || DEFAULT_CONTENT.subject2,
          reference: data?.reference?.trim() || DEFAULT_CONTENT.reference,
          default_content: data?.default_content?.trim() || DEFAULT_CONTENT.default_content,
          officer_name: data?.officer_name?.trim() || DEFAULT_CONTENT.officer_name,
  officer_designation: data?.officer_designation?.trim() || DEFAULT_CONTENT.officer_designation
        };

        setTippani(loadedData);
        setFormData(loadedData);
      } catch (err) {
        console.error("Error loading Objection tippani:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchTippani();
  }, [projectId, proposalId]);

  const handleEditClick = () => {
    setFormData({ ...tippani });
    setOpen(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!projectId || !proposalId) {
      alert("Project/Proposal ID not found!");
      return;
    }

    try {
      setSaving(true);

      const payload = {
        project_id: projectId,
        proposal_id: proposalId,
        tippani_type: "Objection",
        subject: formData.subject.trim(),
        subject2: formData.subject2.trim(),
        reference: formData.reference.trim(),
        default_content: formData.default_content.trim(),
        officer_name: formData.officer_name.trim(),
  officer_designation: formData.officer_designation.trim()
      };

      await apiService.postAddUpdateTippani(payload);

      setTippani({ ...formData });
      setOpen(false);
      alert("✓ प्रारूप यादी यशस्वीपणे जतन झाली!");
    } catch (err) {
      console.error("Save failed:", err);
      alert("❌ जतन करताना त्रुटी आली");
    } finally {
      setSaving(false);
    }
  };

  const handleUploadedFile = (e) => {
  const file = e.target.files[0];
  if (!file) return;

  resetSignatureState();     // 🔥 important
  setPdfForSigning(file);
  setShowSignaturePad(true);
};

 useEffect(() => {
  if (!selectedSignDocument) return;

  const postSignedPdf = async () => {
    try {
      const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
      const projectId = selectedProject?.id || selectedProject?.project_id;
      const proposalId = localStorage.getItem("currentProposalId");

      if (!projectId || !proposalId) {
        console.error("Missing projectId or proposalId");
        return;
      }

      await apiService.postAddSignaturePDF(
        projectId,
        proposalId,
        "AkshepTappani",      // 🔁 change per section
        selectedSignDocument   // ✅ signed PDF only
      );

      const sectionRes = await apiService.getSectionFile(
        projectId,
        proposalId,
        "AkshepTappani"
      );

      if (sectionRes?.isSignAvailable && sectionRes.data?.[0]?.file_path) {
        setPreviewUrl(sectionRes.data[0].file_path);
      }

    } catch (error) {
      console.error("Error posting signed PDF:", error);
    }
  };

  postSignedPdf();
}, [selectedSignDocument]);

const handleViewSignedPdf = async () => {
  try {
    const selectedProject = JSON.parse(localStorage.getItem("selectedProject") || "{}");
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId = localStorage.getItem("currentProposalId");

    if (!projectId || !proposalId) {
      alert("Project or Proposal not found");
      return;
    }

    const res = await apiService.getSectionFile(
      projectId,
      proposalId,
      "AkshepTappani" // 🔁 change per section
    );

    if (res?.isSignAvailable && res?.data?.[0]?.file_path) {
      setViewerFile(res.data[0].file_path);
      setIsViewerOpen(true);     // modal
      // OR 👉 window.open(res.data[0].file_path, "_blank");
    } else {
      alert("Signed document not available");
    }
  } catch (error) {
    console.error("Error viewing signed PDF:", error);
    alert("Unable to open signed document");
  }
};

const SignatureLoader = ({ text }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div className="bg-white rounded-lg p-6 flex flex-col items-center space-y-4">
      <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
      <p className="text-sm font-medium text-gray-700">{text}</p>
    </div>
  </div>
);

  const handlePrint = () => {
    const content = printRef.current?.innerHTML;
    if (!content) return;

    const original = document.body.innerHTML;
    document.body.innerHTML = content;
    window.print();
    document.body.innerHTML = original;
    window.location.reload();
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <p className="text-xl font-semibold">लोड होत आहे...</p>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      {/* Action Buttons */}
      <div className="flex justify-start gap-4 mb-6">

      {/* <button className="relative">
                  <label className="flex items-center space-x-2 px-4 py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 cursor-pointer">
                    <Upload size={18} />
                    <span>Upload Signature</span>
                    <input
                      type="file"
                      accept="application/pdf,image/*"
                      className="hidden"
                      onChange={handleUploadedFile}
                    />
                  </label>
                </button>
      
                <button
                onClick={handleViewSignedPdf}
                className="flex items-center space-x-2 px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700"
              >
                <Printer size={18} />
                <span>View Signed PDF</span>
              </button> */}
        <button
          onClick={handleEditClick}
          disabled={saving}
          className="flex items-center gap-2 px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow transition-colors"
        >
          <Pencil size={18} />
          संपादित करा
        </button>

        <button
          onClick={handlePrint}
          disabled={saving}
          className="flex items-center gap-2 px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow transition-colors"
        >
          <Printer size={18} />
          प्रिंट
        </button>
      </div>

      {/* Printable Area */}
      <div
        ref={printRef}
        className="bg-white mx-auto max-w-4xl p-10 text-black shadow-lg"
        style={{
          fontFamily: "'Noto Serif Devanagari', serif",
          lineHeight: "2.1",
          fontSize: "15.5px",
          border: "2.2px solid #000"
        }}
      >
        <h2 className="text-center font-bold text-xl mb-1">कार्यालयीन टिप्पणी</h2>
        <h3 className="text-center font-semibold text-lg">पुनर्वसन विभाग</h3>
        <h3 className="text-center font-semibold mb-8">
          जिल्हाधिकारी कार्यालय, बुलढाणा
        </h3>

        <p>
          <strong>विषय :-</strong>{" "}
          {tippani.subject.trim() || DEFAULT_CONTENT.subject}
        </p>

        <p className="mt-2">
          {tippani.subject2.trim() || DEFAULT_CONTENT.subject2}
        </p>

        <p className="mt-4">
          <strong>संदर्भ :-</strong>
        </p>

        <div className="mt-2 ml-6 whitespace-pre-wrap">
          {tippani.reference.trim() 
            ? tippani.reference 
            : DEFAULT_CONTENT.reference}
        </div>

        <div className="text-center my-6 font-bold">***</div>

        <div className="mt-4 text-justify whitespace-pre-wrap">
          {tippani.default_content.trim() 
            ? tippani.default_content 
            : DEFAULT_CONTENT.default_content}
        </div>

        {/* Signature */}
        <div className="mt-16 flex justify-between text-lg">
          <div className="signature">
          <div className="font-bold">{fullName}</div>
          <div>{designation}</div>
        </div>

          <div className="text-right">
  <p className="font-semibold">
    {tippani.officer_designation || DEFAULT_CONTENT.officer_designation}
  </p>
  <p>
    ({tippani.officer_name || DEFAULT_CONTENT.officer_name})
  </p>
</div>

        </div>
      </div>

      {/* Edit Modal */}
      {open && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[92vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-5">
                <h2 className="text-2xl font-bold">प्रारूप टिप्पणी संपादित करा</h2>
                <button
                  onClick={() => setOpen(false)}
                  className="text-gray-500 hover:text-gray-800"
                >
                  <X size={28} />
                </button>
              </div>

              <div className="space-y-5">
                <div>
                  <label className="block font-medium mb-1">विषय</label>
                  <input
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">विषय (दुसरी ओळ)</label>
                  <input
                    name="subject2"
                    value={formData.subject2}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">संदर्भ (प्रत्येक ओळ वेगळी करा)</label>
                  <textarea
                    name="reference"
                    value={formData.reference}
                    onChange={handleChange}
                    rows={6}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500"
                    placeholder="प्रत्येक संदर्भ नवीन ओळीवर..."
                  />
                </div>

                <div>
                  <label className="block font-medium mb-1">मुख्य मजकूर</label>
                  <textarea
                    name="default_content"
                    value={formData.default_content}
                    onChange={handleChange}
                    rows={14}
                    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 font-serif leading-relaxed"
                  />
                </div>

                <div>
  <label className="block font-medium mb-1">अधिकाऱ्याचे पद</label>
  <input
    name="officer_designation"
    value={formData.officer_designation}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500"
    placeholder="उदा. ग्राम महसूल अधिकारी"
  />
</div>

<div>
  <label className="block font-medium mb-1">अधिकाऱ्याचे नाव</label>
  <input
    name="officer_name"
    value={formData.officer_name}
    onChange={handleChange}
    className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500"
    placeholder="उदा. एम.के. जाधव"
  />
</div>

              </div>

              <div className="flex justify-end gap-4 mt-8">
                <button
                  onClick={() => setOpen(false)}
                  disabled={saving}
                  className="px-6 py-2.5 bg-gray-500 hover:bg-gray-600 text-white rounded-lg transition-colors"
                >
                  रद्द करा
                </button>

                <button
                  onClick={handleSave}
                  disabled={saving}
                  className="flex items-center gap-2 px-6 py-2.5 bg-green-600 hover:bg-green-700 text-white rounded-lg shadow transition-colors min-w-[140px] justify-center"
                >
                  {saving ? "सेव्ह होत आहे..." : (
                    <>
                      <Save size={18} /> जतन करा
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSignaturePad && pdfForSigning && (
  <SignaturePad
    pdfFile={pdfForSigning}
    onSign={(signaturesArray) => {
      setShowSignaturePad(false);

      // ✅ ONLY sign here
      signDocument(pdfForSigning, signaturesArray);

      setPdfForSigning(null);
    }}
    onCancel={() => {
      setShowSignaturePad(false);
      setPdfForSigning(null);
    }}
  />
)}

{isViewerOpen && viewerFile && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60">
    <div className="bg-white rounded-lg w-[80%] max-w-6xl h-[80%] relative">

      <div className="flex justify-between items-center px-4 py-2 border-b">
        <h3 className="text-lg font-semibold">Signed Document</h3>
        <button
          onClick={() => setIsViewerOpen(false)}
          className="text-xl font-bold"
        >
          ✕
        </button>
      </div>

      <iframe
        src={viewerFile}
        title="Signed PDF Viewer"
        className="w-full h-full"
      />
    </div>
  </div>
)}

{(uploadStatus === "signing" || uploadStatus === "uploading") && (
  <SignatureLoader
    text={
      uploadStatus === "signing"
        ? "Applying digital signature…"
        : "Uploading signed document…"
    }
  />
)}
    </div>
  );
};

export default AkshepList;
